import React from "react";
export default function IncludedBaggage() {
  return (
    <div className=" bg-white lg:rounded-xl px-4 py-6 xl:p-6 w-full space-y-4">
      <h2 className="font-medium text-xl sm:text-2xl text-dark">
        Included Baggage
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-4">
        <div className="flex gap-2 xl:gap-4 items-start p-3 rounded-lg bg-brand-blue-80">
          <div className="shrink-0 w-10 h-10 rounded-[6px] bg-white flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                fill="#0236C7"
                d="M12 6a3 3 0 100-6 3 3 0 000 6zM19.92 14.606l-2.48-5.788A3 3 0 0014.681 7H9.32c-1.2 0-2.285.715-2.757 1.818l-2.48 5.788a1 1 0 101.838.788l2.081-4.856V23a1 1 0 002 0v-6h4v6a1 1 0 002 0V10.538l2.081 4.856a.999.999 0 001.313.524 1 1 0 00.525-1.313l-.002.001z"
              ></path>
            </svg>
          </div>
          <div className="space-y-1">
            <h3 className="text-lg sm:text-xl font-bold text-brand-blue-100">
              John Doe
            </h3>
            <ul className="divide-x divide-brand-gray-light flex flex-wrap items-center">
              <li className="px-2 first:pl-0 last:pr-0  text-sm sm:text-base text-dark">
                Adult
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Male
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Sept. 10, 1968
              </li>
            </ul>
          </div>
        </div>
        <div className="flex gap-2 xl:gap-4 items-start p-3 rounded-lg bg-brand-red-20">
          <div className="shrink-0 w-10 h-10 rounded-[6px] bg-white flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              fill="none"
              viewBox="0 0 25 24"
            >
              <path
                fill="#FC1A02"
                d="M12.334 7a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM16.738 10.051A2.996 2.996 0 0013.892 8h-3.117a2.996 2.996 0 00-2.846 2.051l-2.544 7.632a1 1 0 00.95 1.316h2v4a1 1 0 001 1h6a1 1 0 001-1v-4h2a1 1 0 00.948-1.316l-2.545-7.632z"
              ></path>
            </svg>
          </div>
          <div className="space-y-1">
            <h3 className="text-lg sm:text-xl font-bold text-brand-blue-100">
              John Doe
            </h3>
            <ul className="divide-x divide-brand-gray-light flex flex-wrap items-center">
              <li className="px-2 first:pl-0 last:pr-0  text-sm sm:text-base text-dark">
                Adult
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Female
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Jan. 24, 1969
              </li>
            </ul>
          </div>
        </div>
        <div className="flex gap-2 xl:gap-4 items-start p-3 rounded-lg bg-brand-blue-80">
          <div className="shrink-0 w-10 h-10 rounded-[6px] bg-white flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              fill="none"
              viewBox="0 0 25 24"
            >
              <path
                fill="#0236C7"
                d="M12.666 7a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
              ></path>
              <path
                fill="#0236C7"
                d="M8.666 13h8v-2.88L22.786 4l-1.528-1.529L14.858 8h-4.385l-6.4-5.529L2.546 4l6.12 6.12V13zM10.893 16.581l-2.527-2.019-1.9 2.538a1.5 1.5 0 00-.086 1.671l3 5 1.948-1.171-1.857-4.51 1.422-1.509zM14.439 16.581l2.527-2.019 1.9 2.538a1.5 1.5 0 01.086 1.671l-3 5-1.948-1.171 1.857-4.51-1.422-1.509z"
              ></path>
            </svg>
          </div>
          <div className="space-y-1">
            <h3 className="text-lg sm:text-xl font-bold text-brand-blue-100">
              Bill Doe
            </h3>
            <ul className="divide-x divide-brand-gray-light flex flex-wrap items-center">
              <li className="px-2 first:pl-0 last:pr-0  text-sm sm:text-base text-dark">
                Child
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Male
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Sept. 10, 1968
              </li>
            </ul>
          </div>
        </div>
        <div className="flex gap-2 xl:gap-4 items-start p-3 rounded-lg bg-brand-blue-80">
          <div className="shrink-0 w-10 h-10 rounded-[6px] bg-white flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              fill="none"
              viewBox="0 0 24 25"
            >
              <path
                fill="#0236C7"
                d="M22.5 21.5h-21a1.5 1.5 0 110-3h21a1.5 1.5 0 110 3zM21.035 11a2.967 2.967 0 10-.003 5.934A2.967 2.967 0 0021.035 11zM13.5 12.5H7.677l1.173-2.33a1.5 1.5 0 00-.51-1.918L2.585 4.42.92 6.916l4.65 3.099-1.326 2.643A3 3 0 006.927 17H12a4.5 4.5 0 004.5-4.5v-6h-3v6z"
              ></path>
            </svg>
          </div>
          <div className="space-y-1">
            <h3 className="text-lg sm:text-xl font-bold text-brand-blue-100">
              Terrence Doe
            </h3>
            <ul className="divide-x divide-brand-gray-light flex flex-wrap items-center">
              <li className="px-2 first:pl-0 last:pr-0  text-sm sm:text-base text-dark">
                Infant on Lap
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Male
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Sept. 10, 1968
              </li>
            </ul>
          </div>
        </div>
        <div className="flex gap-2 xl:gap-4 items-start p-3 rounded-lg bg-brand-blue-80">
          <div className="shrink-0 w-10 h-10 rounded-[6px] bg-white flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="21"
              fill="none"
              viewBox="0 0 25 21"
            >
              <path
                fill="#0236C7"
                d="M9.334 15a1.5 1.5 0 01-1.06-2.56l12-12a1.5 1.5 0 012.12 2.12l-12 12a1.5 1.5 0 01-1.06.44z"
              ></path>
              <path
                fill="#0236C7"
                d="M24.263 15.691a4.526 4.526 0 00-3.63-3.62 4.442 4.442 0 00-2.832.422 7.97 7.97 0 01-3.644 1.007h-.582l-2.12 2.121a3 3 0 11-4.243-4.242l.86-.86-.963-7.697A3 3 0 003.76.218L1.724.47A1.5 1.5 0 00.422 2.147L2.45 18.372A3 3 0 005.433 21h14.4a4.5 4.5 0 004.43-5.309zM19.833 18a1.5 1.5 0 110-2.999 1.5 1.5 0 010 2.999z"
              ></path>
            </svg>
          </div>
          <div className="space-y-1">
            <h3 className="text-lg sm:text-xl font-bold text-brand-blue-100">
              Claire Doe
            </h3>
            <ul className="divide-x divide-brand-gray-light flex flex-wrap items-center">
              <li className="px-2 first:pl-0 last:pr-0  text-sm sm:text-base text-dark">
                Infant on Lap
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Male
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Sept. 10, 1968
              </li>
            </ul>
          </div>
        </div>
        <div className="flex gap-2 xl:gap-4 items-start p-3 rounded-lg bg-brand-red-20">
          <div className="shrink-0 w-10 h-10 rounded-[6px] bg-white flex justify-center items-center">
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="none"
              viewBox="0 0 25 25"
            >
              <g fill="#FC1A02" clipPath="url(#clip0_155_13783)">
                <path d="M11.666 6.5a3 3 0 100-6 3 3 0 000 6zM20.666 23.5a.75.75 0 01-.75-.75V16.5a1.252 1.252 0 00-1.25-1.25.75.75 0 010-1.5 2.752 2.752 0 012.75 2.75v6.25a.75.75 0 01-.75.75zM15.373 17.793l-2.365-2.365a2.988 2.988 0 01-1.235 1.593l1.786 1.786-.863 3.45a1 1 0 101.941.485l1-4.001a1 1 0 00-.263-.949v.001z"></path>
                <path d="M17.379 14.201a1 1 0 00-.013-1.414l-4.821-4.729a1.97 1.97 0 00-2.2-.374l-4.1 1.91a.996.996 0 00-.517.566l-1.44 3.998a.999.999 0 101.882.676l1.297-3.606 1.45-.676-.711 3.553c-.065.331-.044.673.06.993l1.3 4.246-1.731 2.599a1.001 1.001 0 001.664 1.11l1.998-2.997c.169-.253.214-.568.124-.858l-.867-2.794a1.993 1.993 0 001.374-1.513l.743-3.718 3.096 3.039a1 1 0 001.414-.013l-.002.002z"></path>
              </g>
              <defs>
                <clipPath id="clip0_155_13783">
                  <path
                    fill="#fff"
                    d="M0 0H24V24H0z"
                    transform="translate(.666 .5)"
                  ></path>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="space-y-1">
            <h3 className="text-lg sm:text-xl font-bold text-brand-blue-100">
              Christine Smith
            </h3>
            <ul className="divide-x divide-brand-gray-light flex flex-wrap items-center">
              <li className="px-2 first:pl-0 last:pr-0  text-sm sm:text-base text-dark">
                Senior
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Female
              </li>
              <li className="px-2 first:pl-0 last:pr-0 text-sm sm:text-base text-dark">
                Jan. 24, 1969
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
